import { render, staticRenderFns } from "./ReviewTicket.vue?vue&type=template&id=468959f7&"
import script from "./ReviewTicket.vue?vue&type=script&lang=ts&"
export * from "./ReviewTicket.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports